import { render } from "./Test.vue?vue&type=template&id=28eac3d3"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__